/* eslint-disable */
// src/pages/SmrutiGallery.tsx — Share to feed + Unpost + warm theme
import React, { useState, useEffect, useRef } from 'react';
import { ref, get, remove, set, update } from 'firebase/database';
import { db } from '../environments/firebase';
import { useAuth } from '../contexts/AuthContext';
import { motion, AnimatePresence } from 'framer-motion';

const T = {
  bg:       '#F7F5F0',
  surface:  '#FFFFFF',
  surface2: '#F0EDE8',
  border:   '#E5E0D8',
  text:     '#1A1714',
  muted:    '#8A8178',
  accent:   '#C2610A',
  accentBg: '#FEF3E8',
  green:    '#15803D',
  red:      '#DC2626',
  shadow:   '0 1px 3px rgba(0,0,0,0.07), 0 1px 2px rgba(0,0,0,0.04)',
  shadowMd: '0 4px 12px rgba(0,0,0,0.08)',
};

const Ic = {
  Play:     () => <svg width="18" height="18" fill="currentColor" viewBox="0 0 24 24"><polygon points="5 3 19 12 5 21 5 3"/></svg>,
  Pause:    () => <svg width="18" height="18" fill="currentColor" viewBox="0 0 24 24"><rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/></svg>,
  Search:   () => <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>,
  Close:    () => <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>,
  Share:    () => <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>,
  Copy:     () => <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/></svg>,
  Trash:    () => <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"/></svg>,
  Download: () => <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>,
  Left:     () => <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"/></svg>,
  Right:    () => <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"/></svg>,
  Calendar: () => <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>,
  Users:    () => <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></svg>,
  Globe:    () => <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/></svg>,
  Unpost:   () => <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/></svg>,
};

interface Smruti {
  id: string; title: string; description: string;
  date: string | Date | { toDate: () => Date };
  withWhom: string; mediaType: string; mediaUrl: string; createdAt: any;
  isPublic?: boolean;
}

export default function SmrutiGallery() {
  const { currentUser } = useAuth();
  const [smrutis, setSmrutis]               = useState<Smruti[]>([]);
  const [filtered, setFiltered]             = useState<Smruti[]>([]);
  const [loading, setLoading]               = useState(true);
  const [searchTerm, setSearchTerm]         = useState('');
  const [currentAudio, setCurrentAudio]     = useState<string | null>(null);
  const [isPlaying, setIsPlaying]           = useState(false);
  const [selectedMedia, setSelectedMedia]   = useState<Smruti | null>(null);
  const [expanded, setExpanded]             = useState<Record<string, boolean>>({});
  const [showDelete, setShowDelete]         = useState<string | null>(null);
  const [postingId, setPostingId]           = useState<string | null>(null);
  const [unpostingId, setUnpostingId]       = useState<string | null>(null);

  useEffect(() => {
    if (!currentUser) return;
    get(ref(db, `users/${currentUser.uid}/smruti`)).then(snap => {
      if (!snap.exists()) { setSmrutis([]); setLoading(false); return; }
      const arr = Object.entries(snap.val()).map(([id, val]: any) => ({ id, ...val }));
      arr.sort((a: any, b: any) => b.createdAt - a.createdAt);
      setSmrutis(arr); setFiltered(arr);
    }).finally(() => setLoading(false));
  }, [currentUser]);

  useEffect(() => {
    if (!searchTerm.trim()) { setFiltered(smrutis); return; }
    const q = searchTerm.toLowerCase();
    setFiltered(smrutis.filter(s =>
      s.title.toLowerCase().includes(q) ||
      s.description.toLowerCase().includes(q) ||
      (s.withWhom && s.withWhom.toLowerCase().includes(q))
    ));
  }, [searchTerm, smrutis]);

  const formatDate = (ts: any) => {
    if (!ts || ts === 'unknown') return 'Date not remembered';
    const d = typeof ts === 'string' ? new Date(ts) : typeof ts === 'object' && 'toDate' in ts ? ts.toDate() : ts as Date;
    return d.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  };

  const handlePlayPause = (url: string) => {
    const el = document.getElementById('audio-player') as HTMLAudioElement;
    if (currentAudio === url) { isPlaying ? el.pause() : el.play(); setIsPlaying(p => !p); }
    else { setCurrentAudio(url); setIsPlaying(true); setTimeout(() => el.play(), 100); }
  };

  const copyLink = (s: Smruti) => {
    navigator.clipboard.writeText(`${window.location.origin}/share/smruti/${s.id}`)
      .then(() => alert('Link copied!')).catch(() => alert('Failed to copy'));
  };

  const share = async (s: Smruti) => {
    const data = { title: s.title, text: s.description, url: `${window.location.origin}/share/smruti/${s.id}` };
    try { if (navigator.share && navigator.canShare(data)) await navigator.share(data); else copyLink(s); }
    catch { copyLink(s); }
  };

  const deleteSmruti = async (id: string) => {
    if (!currentUser) return;
    const smruti = smrutis.find(s => s.id === id);
    // Remove from public feed too if posted
    if (smruti?.isPublic) {
      const feedId = `smruti_${currentUser.uid}_${smruti.createdAt}`;
      await remove(ref(db, `publicFeed/${feedId}`)).catch(() => {});
    }
    await remove(ref(db, `users/${currentUser.uid}/smruti/${id}`));
    setSmrutis(p => p.filter(s => s.id !== id));
    setFiltered(p => p.filter(s => s.id !== id));
    setShowDelete(null);
    if (selectedMedia?.id === id) setSelectedMedia(null);
  };

  // ── Share smruti to public feed ──────────────────────────────
  const shareToFeed = async (s: Smruti) => {
    if (!currentUser || s.isPublic) return;
    setPostingId(s.id);
    try {
      const profSnap = await get(ref(db, `users/${currentUser.uid}/profile`));
      let displayName = currentUser.email?.split('@')[0] || 'Devotee';
      let avatarUrl: string | null = null;
      if (profSnap.exists()) {
        const pr = profSnap.val();
        displayName = `${pr.firstName||''} ${pr.lastName||''}`.trim() || displayName;
        avatarUrl = pr.avatarUrl || null;
      }
      const feedId = `smruti_${currentUser.uid}_${s.createdAt}`;
      await set(ref(db, `publicFeed/${feedId}`), {
        type:          'smruti',
        userId:        currentUser.uid,
        displayName,
        avatarInitial: displayName.charAt(0).toUpperCase(),
        avatarUrl,
        title:         s.title,
        description:   s.description,
        date:          s.date,
        withWhom:      s.withWhom || '',
        mediaType:     s.mediaType,
        mediaUrl:      s.mediaUrl,
        topic:         s.title,
        vakta:         s.withWhom ? `With ${s.withWhom}` : '',
        caption:       s.description,
        dateTime:      new Date(s.createdAt).toISOString(),
        notes:         '',
        images:        s.mediaType === 'image' && s.mediaUrl ? [s.mediaUrl] : [],
        audioFiles:    s.mediaType === 'audio' && s.mediaUrl ? [s.mediaUrl] : [],
        createdAt:     s.createdAt,
        likes: {}, comments: {}, saves: {},
      });
      // Mark smruti as public
      await update(ref(db, `users/${currentUser.uid}/smruti/${s.id}`), { isPublic: true });
      setSmrutis(prev => prev.map(x => x.id === s.id ? { ...x, isPublic: true } : x));
      setFiltered(prev => prev.map(x => x.id === s.id ? { ...x, isPublic: true } : x));
      if (selectedMedia?.id === s.id) setSelectedMedia(prev => prev ? { ...prev, isPublic: true } : null);
      alert('Smruti shared to community feed!');
    } catch (e) { console.error(e); alert('Failed to share. Check Firebase rules.'); }
    finally { setPostingId(null); }
  };

  // ── Unpost smruti from feed ──────────────────────────────────
  const unpostFromFeed = async (s: Smruti) => {
    if (!currentUser || !window.confirm('Remove this smruti from the public feed?')) return;
    setUnpostingId(s.id);
    try {
      const feedId = `smruti_${currentUser.uid}_${s.createdAt}`;
      await remove(ref(db, `publicFeed/${feedId}`));
      await update(ref(db, `users/${currentUser.uid}/smruti/${s.id}`), { isPublic: false });
      setSmrutis(prev => prev.map(x => x.id === s.id ? { ...x, isPublic: false } : x));
      setFiltered(prev => prev.map(x => x.id === s.id ? { ...x, isPublic: false } : x));
      if (selectedMedia?.id === s.id) setSelectedMedia(prev => prev ? { ...prev, isPublic: false } : null);
      alert('Removed from community feed.');
    } catch (e) { console.error(e); alert('Failed to unpost.'); }
    finally { setUnpostingId(null); }
  };

  const navigate = (dir: 'prev' | 'next') => {
    if (!selectedMedia) return;
    const idx = filtered.findIndex(s => s.id === selectedMedia.id);
    const next = dir === 'prev' ? (idx > 0 ? idx - 1 : filtered.length - 1) : (idx < filtered.length - 1 ? idx + 1 : 0);
    setSelectedMedia(filtered[next]);
  };

  const getMediaTypeBadge = (type: string) => {
    const map: Record<string, { emoji: string; color: string }> = {
      image: { emoji: '🖼️', color: '#D97706' },
      audio: { emoji: '🎵', color: '#7C3AED' },
      video: { emoji: '🎬', color: '#059669' },
    };
    return map[type] || { emoji: '📄', color: T.muted };
  };

  return (
    <div style={{ minHeight: '100vh', background: T.bg, fontFamily: "-apple-system,'Helvetica Neue',sans-serif", color: T.text }}>
      <audio id="audio-player" src={currentAudio || undefined} onEnded={() => setIsPlaying(false)} />

      <div style={{ maxWidth: 1120, margin: '0 auto', padding: '24px 16px' }}>
        {/* Header */}
        <div style={{ marginBottom: 24 }}>
          <h1 style={{ fontFamily: 'Georgia, serif', fontSize: 26, fontWeight: 700, color: T.text, margin: '0 0 4px' }}>📿 Your Smruti Gallery</h1>
          <p style={{ color: T.muted, margin: 0, fontSize: 14 }}>Browse your collection of spiritual memories</p>
        </div>

        {/* Search */}
        <div style={{ position: 'relative', maxWidth: 400, marginBottom: 24 }}>
          <div style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', color: T.muted }}>
            <Ic.Search />
          </div>
          <input
            type="text" placeholder="Search smrutis…" value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
            style={{ width: '100%', boxSizing: 'border-box', paddingLeft: 40, paddingRight: searchTerm ? 38 : 14, paddingTop: 10, paddingBottom: 10, background: T.surface, border: `1px solid ${T.border}`, borderRadius: 10, outline: 'none', fontSize: 14, color: T.text, fontFamily: 'inherit', boxShadow: T.shadow }}
          />
          {searchTerm && (
            <button onClick={() => setSearchTerm('')} style={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: T.muted }}>
              <Ic.Close />
            </button>
          )}
        </div>

        {loading ? (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 256 }}>
            <div style={{ width: 40, height: 40, border: `3px solid ${T.border}`, borderTopColor: T.accent, borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
          </div>
        ) : filtered.length === 0 ? (
          <div style={{ textAlign: 'center', padding: 64 }}>
            <p style={{ color: T.muted, fontSize: 16 }}>
              {searchTerm ? 'No smrutis match your search.' : 'No smrutis yet. Create your first one!'}
            </p>
          </div>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 16 }}>
            {filtered.map(s => {
              const badge = getMediaTypeBadge(s.mediaType);
              return (
                <motion.div key={s.id}
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  style={{ background: T.surface, borderRadius: 14, border: `1px solid ${T.border}`, overflow: 'hidden', boxShadow: T.shadow, cursor: 'pointer' }}
                  whileHover={{ boxShadow: T.shadowMd }}
                  onClick={() => setSelectedMedia(s)}
                >
                  {/* Media preview */}
                  {s.mediaType === 'image' && s.mediaUrl && (
                    <div style={{ height: 180, overflow: 'hidden' }}>
                      <img src={s.mediaUrl} alt={s.title} style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.3s' }}
                        onMouseEnter={e => { (e.target as HTMLImageElement).style.transform = 'scale(1.04)'; }}
                        onMouseLeave={e => { (e.target as HTMLImageElement).style.transform = 'scale(1)'; }} />
                    </div>
                  )}
                  {s.mediaType === 'video' && s.mediaUrl && (
                    <div style={{ height: 180, background: '#0F0E0C', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
                      <video src={s.mediaUrl} style={{ width: '100%', height: '100%', objectFit: 'cover', opacity: 0.7 }} muted playsInline />
                      <div style={{ position: 'absolute', width: 48, height: 48, borderRadius: '50%', background: 'rgba(255,255,255,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff' }}>
                        <Ic.Play />
                      </div>
                    </div>
                  )}
                  {s.mediaType === 'audio' && s.mediaUrl && (
                    <div style={{ height: 90, background: `linear-gradient(135deg, ${T.accentBg}, #EDE9FE)`, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12, borderBottom: `1px solid ${T.border}` }}>
                      <button onClick={e => { e.stopPropagation(); handlePlayPause(s.mediaUrl); }}
                        style={{ width: 44, height: 44, borderRadius: '50%', background: T.accent, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', border: 'none', cursor: 'pointer', boxShadow: '0 2px 8px rgba(194,97,10,0.3)' }}>
                        {currentAudio === s.mediaUrl && isPlaying ? <Ic.Pause /> : <Ic.Play />}
                      </button>
                      <span style={{ fontSize: 13, color: T.muted }}>🎵 Audio Memory</span>
                    </div>
                  )}

                  <div style={{ padding: '14px 16px' }}>
                    <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 8, marginBottom: 8 }}>
                      <h2 style={{ fontSize: 15, fontWeight: 700, color: T.text, margin: 0, lineHeight: 1.4 }}>{s.title}</h2>
                      <div style={{ display:'flex', alignItems:'center', gap:4, flexShrink:0 }}>
                        {s.isPublic && (
                          <span style={{ fontSize: 10, padding: '2px 6px', borderRadius: 6, background: T.accentBg, color: T.accent, fontWeight: 700, border:`1px solid rgba(194,97,10,0.3)` }}>PUBLIC</span>
                        )}
                        {s.mediaType && (
                          <span style={{ fontSize: 11, padding: '3px 8px', borderRadius: 6, background: T.surface2, color: T.muted, fontWeight: 600 }}>{badge.emoji}</span>
                        )}
                      </div>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', gap: 6, color: T.muted, fontSize: 12, marginBottom: 4 }}>
                      <Ic.Calendar /> <span>{formatDate(s.date)}</span>
                    </div>
                    {s.withWhom && (
                      <div style={{ display: 'flex', alignItems: 'center', gap: 6, color: T.muted, fontSize: 12, marginBottom: 8 }}>
                        <Ic.Users /> <span>With {s.withWhom}</span>
                      </div>
                    )}

                    <p style={{ color: '#5A534D', fontSize: 13, lineHeight: 1.6, margin: '0 0 10px', display: '-webkit-box', WebkitLineClamp: expanded[s.id] ? undefined : 3, WebkitBoxOrient: 'vertical' as any, overflow: expanded[s.id] ? 'visible' : 'hidden' }}>
                      {s.description}
                    </p>
                    {s.description.length > 120 && (
                      <button onClick={e => { e.stopPropagation(); setExpanded(p => ({ ...p, [s.id]: !p[s.id] })); }}
                        style={{ fontSize: 12, color: T.accent, background: 'none', border: 'none', cursor: 'pointer', fontWeight: 600, padding: 0, marginBottom: 10 }}>
                        {expanded[s.id] ? 'Show less' : 'Read more'}
                      </button>
                    )}

                    {/* Action buttons */}
                    <div style={{ display: 'flex', gap: 4, borderTop: `1px solid ${T.border}`, paddingTop: 10, flexWrap:'wrap' }}>
                      {/* Share to feed / Unpost */}
                      {!s.isPublic ? (
                        <button onClick={e => { e.stopPropagation(); shareToFeed(s); }} disabled={postingId === s.id}
                          style={{ display:'flex', alignItems:'center', gap:4, padding:'6px 10px', background:T.accentBg, border:`1px solid rgba(194,97,10,0.3)`, borderRadius:7, cursor:'pointer', fontSize:11, fontWeight:600, color:T.accent, opacity: postingId===s.id ? 0.7:1 }}>
                          <Ic.Globe /> {postingId === s.id ? '…' : 'Share'}
                        </button>
                      ) : (
                        <button onClick={e => { e.stopPropagation(); unpostFromFeed(s); }} disabled={unpostingId === s.id}
                          style={{ display:'flex', alignItems:'center', gap:4, padding:'6px 10px', background:'#FEF3C7', border:`1px solid #FDE68A`, borderRadius:7, cursor:'pointer', fontSize:11, fontWeight:600, color:'#92400E', opacity: unpostingId===s.id ? 0.7:1 }}>
                          <Ic.Unpost /> {unpostingId === s.id ? '…' : 'Unpost'}
                        </button>
                      )}
                      <button onClick={e => { e.stopPropagation(); copyLink(s); }} style={{ padding: '6px 8px', background: 'none', border:`1px solid ${T.border}`, cursor: 'pointer', color: T.muted, borderRadius: 7 }}>
                        <Ic.Copy />
                      </button>
                      <button onClick={e => { e.stopPropagation(); share(s); }} style={{ padding: '6px 8px', background: 'none', border:`1px solid ${T.border}`, cursor: 'pointer', color: T.muted, borderRadius: 7 }}>
                        <Ic.Share />
                      </button>
                      <button onClick={e => { e.stopPropagation(); setShowDelete(s.id); }} style={{ padding: '6px 8px', background: 'none', border:`1px solid ${T.border}`, cursor: 'pointer', color: T.muted, borderRadius: 7, marginLeft:'auto' }}
                        onMouseEnter={e => { e.currentTarget.style.background='#FEF2F2'; e.currentTarget.style.color=T.red; e.currentTarget.style.borderColor='#FECACA'; }}
                        onMouseLeave={e => { e.currentTarget.style.background='none'; e.currentTarget.style.color=T.muted; e.currentTarget.style.borderColor=T.border; }}>
                        <Ic.Trash />
                      </button>
                    </div>
                  </div>
                </motion.div>
              );
            })}
          </div>
        )}
      </div>

      {/* Delete confirm */}
      <AnimatePresence>
        {showDelete && (
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            style={{ position: 'fixed', inset: 0, zIndex: 9000, background: 'rgba(26,23,20,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
            <motion.div initial={{ scale: 0.95 }} animate={{ scale: 1 }}
              style={{ background: T.surface, borderRadius: 18, padding: 28, maxWidth: 360, width: '100%', boxShadow: '0 20px 60px rgba(0,0,0,0.2)' }}>
              <h3 style={{ margin: '0 0 10px', fontSize: 17, fontWeight: 700, color: T.text }}>Delete Smruti?</h3>
              <p style={{ margin: '0 0 20px', color: T.muted, fontSize: 14, lineHeight: 1.6 }}>
                This action cannot be undone. The memory will be permanently removed.
                {smrutis.find(s => s.id === showDelete)?.isPublic && ' It will also be removed from the public feed.'}
              </p>
              <div style={{ display: 'flex', gap: 10 }}>
                <button onClick={() => setShowDelete(null)} style={{ flex: 1, padding: '11px', background: T.surface2, border: `1px solid ${T.border}`, borderRadius: 10, fontSize: 14, fontWeight: 600, cursor: 'pointer', color: T.text }}>Cancel</button>
                <button onClick={() => deleteSmruti(showDelete!)} style={{ flex: 1, padding: '11px', background: T.red, border: 'none', borderRadius: 10, fontSize: 14, fontWeight: 700, cursor: 'pointer', color: '#fff' }}>Delete</button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Media Viewer */}
      <AnimatePresence>
        {selectedMedia && (
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            style={{ position: 'fixed', inset: 0, zIndex: 9000, background: 'rgba(26,23,20,0.92)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}
            onClick={e => { if (e.target === e.currentTarget) setSelectedMedia(null); }}
          >
            <button onClick={() => setSelectedMedia(null)}
              style={{ position: 'absolute', top: 16, right: 16, background: 'rgba(255,255,255,0.1)', border: 'none', borderRadius: '50%', width: 40, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', cursor: 'pointer' }}>
              <Ic.Close />
            </button>
            <button onClick={() => navigate('prev')}
              style={{ position: 'absolute', left: 16, background: 'rgba(255,255,255,0.1)', border: 'none', borderRadius: '50%', width: 44, height: 44, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', cursor: 'pointer' }}>
              <Ic.Left />
            </button>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', maxWidth: 800, width: '100%', gap: 16 }}>
              {selectedMedia.mediaType === 'image' && <img src={selectedMedia.mediaUrl} alt={selectedMedia.title} style={{ maxWidth: '90vw', maxHeight: '55vh', objectFit: 'contain', borderRadius: 12 }} />}
              {selectedMedia.mediaType === 'video' && <video controls autoPlay style={{ maxWidth: '90vw', maxHeight: '55vh', borderRadius: 12 }}><source src={selectedMedia.mediaUrl} /></video>}
              {selectedMedia.mediaType === 'audio' && (
                <div style={{ background: T.surface, borderRadius: 20, padding: 32, textAlign: 'center', width: '100%', maxWidth: 400 }}>
                  <div style={{ fontSize: 48, marginBottom: 16 }}>🎵</div>
                  <button onClick={() => handlePlayPause(selectedMedia.mediaUrl)}
                    style={{ width: 64, height: 64, borderRadius: '50%', background: T.accent, border: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', cursor: 'pointer', margin: '0 auto', boxShadow: '0 4px 16px rgba(194,97,10,0.4)' }}>
                    {currentAudio === selectedMedia.mediaUrl && isPlaying ? <Ic.Pause /> : <Ic.Play />}
                  </button>
                </div>
              )}

              <div style={{ textAlign: 'center', color: '#fff', maxWidth: 600 }}>
                <h3 style={{ fontSize: 18, fontWeight: 700, margin: '0 0 6px' }}>{selectedMedia.title}</h3>
                <p style={{ color: 'rgba(255,255,255,0.65)', margin: '0 0 14px', fontSize: 13, lineHeight: 1.6 }}>{selectedMedia.description}</p>
                <div style={{ display: 'flex', gap: 8, justifyContent: 'center', flexWrap:'wrap' }}>
                  {/* Share / Unpost from viewer */}
                  {!selectedMedia.isPublic ? (
                    <button onClick={() => shareToFeed(selectedMedia)} disabled={postingId === selectedMedia.id}
                      style={{ padding: '8px 14px', background: T.accentBg, border: 'none', borderRadius: 24, color: T.accent, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, fontWeight: 600 }}>
                      <Ic.Globe /> {postingId === selectedMedia.id ? 'Sharing…' : 'Share to Feed'}
                    </button>
                  ) : (
                    <button onClick={() => unpostFromFeed(selectedMedia)} disabled={unpostingId === selectedMedia.id}
                      style={{ padding: '8px 14px', background: '#FEF3C7', border: 'none', borderRadius: 24, color: '#92400E', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, fontWeight: 600 }}>
                      <Ic.Unpost /> {unpostingId === selectedMedia.id ? 'Removing…' : 'Unpost'}
                    </button>
                  )}
                  {selectedMedia.mediaUrl && (
                    <button onClick={() => { const a = document.createElement('a'); a.href = selectedMedia.mediaUrl; a.download = selectedMedia.title; a.click(); }}
                      style={{ padding: '8px 14px', background: 'rgba(255,255,255,0.12)', border: 'none', borderRadius: 24, color: '#fff', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, fontWeight: 600 }}>
                      <Ic.Download /> Download
                    </button>
                  )}
                  <button onClick={() => share(selectedMedia)}
                    style={{ padding: '8px 14px', background: 'rgba(255,255,255,0.12)', border: 'none', borderRadius: 24, color: '#fff', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, fontWeight: 600 }}>
                    <Ic.Share /> Share
                  </button>
                  <button onClick={() => setShowDelete(selectedMedia.id)}
                    style={{ padding: '8px 14px', background: 'rgba(220,38,38,0.3)', border: 'none', borderRadius: 24, color: '#fff', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, fontWeight: 600 }}>
                    <Ic.Trash /> Delete
                  </button>
                </div>
              </div>
            </div>
            <button onClick={() => navigate('next')}
              style={{ position: 'absolute', right: 16, background: 'rgba(255,255,255,0.1)', border: 'none', borderRadius: '50%', width: 44, height: 44, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', cursor: 'pointer' }}>
              <Ic.Right />
            </button>
          </motion.div>
        )}
      </AnimatePresence>

      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
        input::placeholder { color: ${T.muted}; }
        * { box-sizing: border-box; }
      `}</style>
    </div>
  );
}